import React, { useContext } from 'react'
import { Context } from "../contexts/AppContext";
import { Link } from 'react-router-dom';
function GalleryThumbnail({uploadVideoPage}) {

     const { value } = useContext(Context);
      const [appState, setAppState] = value; 

    const galleryBtnhandler=(evt)=>{
    const galleryId = evt.currentTarget.id;
    console.log("gallery hand",appState.allFolderData[appState.currentFolderId])
    const _appState = { 
      ...appState.allFolderData[appState.currentFolderId],  // Spread existing data
      currentGalleryId: galleryId,  // Add galleryId
      currentFolderId:appState.currentFolderId,
      currentDBGalleryId:appState.allFolderData[appState.currentFolderId].galleries[galleryId]._id
  };
  localStorage.setItem('appState', JSON.stringify(_appState));

    setAppState((prevState) => ({ ...prevState,
      currentGalleryName:appState.allFolderData[appState.currentFolderId].galleries[galleryId].name,
      currentGalleryId:galleryId,
      currentDBGalleryId:appState.allFolderData[appState.currentFolderId].galleries[galleryId]._id
    }
    ));
        uploadVideoPage()
    }
  return (
    <div style={{position:'relative', width:"98%", padding:"30px", display:"flex", flexWrap:"wrap", gap:"10px"}}>
{appState.allFolderData[appState.currentFolderId].galleries.map((item,index)=>(
 <Link key={'link'+index}to="/studio">
  <div className='border px-4 py-6 bg-[#f0f2f5] '>
<img id={index} key={"thumb"+index} className='w-[300px] ' src="../../../img/thumbnail/gallery/placeholder-image.jpg"/>
{item.name}
</div>
  {
/*  <button type="button" id={index} key={"thumb"+index} className="flex items-center justify-center
 text-blue-700 hover:text-white border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-48 h-48 text-center me-2 mb-2 dark:border-blue-500 dark:text-blue-500 dark:hover:text-white dark:hover:bg-blue-500 dark:focus:ring-blue-800" onClick={galleryBtnhandler}>{item.name}
 </button>*/
  }

 </Link>
))}
        
    </div>
  )
}

export default GalleryThumbnail